import React from "react";
import { PageLayoutsContext } from "../context/page-layouts-context";
export var usePageLayouts = function () {
  return React.useContext(PageLayoutsContext);
};